<template>
  <div :class="{'dh-psy-header-wrapper dh-psy-header-wrapper--intro': true, [`dh-psy-header-wrapper--${heroBackground}`]: heroBackground, 'dh-psy-header-wrapper--in-view': inViewport }">
    <div class="dh-psy-header__intro-bg">
      <AnimatedImg v-if="heroImage" :value="percentValue" :imageId="heroImage" />
    </div>
    <InViewport @percent-change="percentChange" @bottom-change="bottomChange" @inviewport-change="inViewportChange" no-normalize>
      <div slot="item" class="dh-psy-header__content-wrapper">
        <Intro v-if="hasIntro" :offsetStyle="style" />
      </div>
    </InViewport>

  </div>
</template>

<style scoped src="./with-intro.css">
</style>

<script>
import HeaderTitle from '../Typography/Title.vue'
import IntroImage from '../Media/Images/SrcSet.vue'
import AnimatedImg from '../Media/Images/AnimateImg.vue'
import Intro from '../Intro/index.vue'
import Byline from '../Body/Byline.vue'
import InViewport from '../Utilities/InViewport.vue'
import normalize from '../../lib/normalize'

import { createImageUrl, createSrcSet } from '../../lib/image-utils.js'

export default {
  computed: {
    title() {
      return [this.$root.$data.props.doc.title]
    },
    imageId() {
      return this.$root.$data.props.doc['hero-image']
    },
    headerImage() {
      const smallWidths = [320, 400, 450, 650]
      const largeWidths = [1200, 1360, 1550, 1800, 2400]
      const id = this.$root.$data.props.doc['hero-image']
      return {
        smallSrcSet: createSrcSet({ id, widths: smallWidths, ratio: '3:4' }),
        smallSrc: createImageUrl({ id, width: 400, ratio: '3:4' }),
        mediumSrc: createImageUrl({ id, width: 1200, ratio: '1:1' }),
        mediumSrcSet: createSrcSet({ id, widths: largeWidths, ratio: '1:1' }),
        largeSrc: createImageUrl({ id, width: 1200, ratio: '16:9' }),
        largeSrcSet: createSrcSet({ id, widths: largeWidths, ratio: '16:9' })
      }
    },
    opacity() {
      if (this.bottom !== null && this.inViewport) {
        if (this.hasIntro) {
          if (this.bottom < 0) {
            return 1
          } else if (this.bottom > 100) {
            return 0
          }

          const val = Math.max(0, this.bottom - 33)
          return 1 - normalize(val, 0, 0.8, 0, 33)
        }
        const value = -100 + this.top
        const res = Math.max(0, (100 - Math.abs((value ** 2 * 4) / 100)) / 100)

        return res
      }
      return 1
    },
    style() {
      if (this.bottom !== null && this.inViewport) {
        if (this.hasIntro) {
          const val = Math.max(0, this.bottom)

          const normalizedValue = normalize(val, 0, 2, 0, 100) * 1 ** 5
          if (normalizedValue === 0) return {}

          return {
            transform: `translate3d(0, -${normalizedValue * 15}%, 0)`,
            transition: '0.05s transform linear',
            opacity: this.opacity
          }
        }
        const value = (-100 + this.top) * 0.3 ** 2

        const normalizedValue = Math.max(-20, Math.min(value, 20))

        return {
          transform: `translate(0, -${normalizedValue}%)`,
          transition: '0.05s transform linear',
          opacity: this.opacity
        }
      }
    }
  },
  data() {
    return {
      inViewport: null,
      bottom: null,
      top: 0,
      percentValue: 100,
      shouldReveal: true,
      hasIntro: this.$root.$data.props.doc.intro,
      heroImage: this.$root.$data.props.doc['hero-image'],
      heroBackground: this.$root.$data.props.doc['hero-background']
    }
  },
  methods: {
    percentChange(e) {
      if (e.percent > 100 || e.percent < 0) {
        return
      }
      this.percentValue = 100 - e.percent
    },
    bottomChange(e) {
      if (e.bottom > 200) return
      if (e.bottom < -10) return
      this.bottom = e.bottom
    },
    inViewportChange(e) {
      this.inViewport = e.isInViewport
      if (!e.isInViewport) {
        const el = document.querySelector('.dh-psy-masthead')
        if (el) {
          el.classList.remove('dh-psy-masthead--white')
        }
      } else {
        const el = document.querySelector('.dh-psy-masthead')
        if (el && this.heroBackground !== 'white') {
          el.classList.add('dh-psy-masthead--white')
        }
      }
    }
  },
  components: {
    HeaderTitle,
    Intro,
    InViewport,
    Byline,
    IntroImage,
    AnimatedImg
  }
}
</script>
